import React, { useState } from "react";
import "./SapAbap.css";
import DownloadForm from "../DownloadForm/DownloadForm";

const SapPS = () => {
  const [showForm, setShowForm] = useState(false);

  const handleDownloadClick = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="sapfincon-wrapper">
      {/* Animated Background Circles */}
      <div className="background-animation">
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
      </div>

      {/* Header Section */}
      <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: "90px" }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1">Project Systems</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">SAP</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="sapfincon-flexbox">
        <div className="sapfincon-left">
          <div className="sapfincon-wrapper zoom-effect">
            <img
              src="/assets/img/sapfince.jpg"
              alt="SAP Banner"
              className="sapfincon-main-image"
            />
          </div>
        </div>
        <div className="sapfincon-right">
          <h2 className="sapfincon-title">Master Project Planning & Execution with BDM Technology’s SAP PS Course</h2>
          <p className="sapfincon-description">
            SAP Project Systems (PS) is the go-to ERP solution for project-based industries seeking to manage costs, timelines, and resources effectively. From planning and budgeting to execution and closure, SAP PS ensures total visibility and control across your projects.
          </p>
          <ul className="sapfincon-list">
            {[
              "Project-Centric ERP Module – Specifically built for managing project planning and execution.",
              "Complete Project Lifecycle Management – Supports WBS structures, networks, milestones, and budgets.",
              "Integrated with Other SAP Modules – Seamless collaboration with FICO, MM, SD, and HCM.",
              "Real-Time Project Monitoring – Ensures timely delivery and cost optimization.",
              "Essential for EPC & Infra Industries – Widely used in engineering, construction, and capital-intensive sectors.",
              "Multiple Career Paths – Project controllers, SAP PS consultants, project planners, and more.",
            ].map((text, idx) => (
              <li className="sapfincon-list-item" key={idx}>
                <span className="sapfincon-icon">
                  <svg aria-hidden="true" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998
                      26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997
                      26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206
                      0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                  </svg>
                </span>
                <span className="sapfincon-text">{text}</span>
              </li>
            ))}
          </ul>
          <p className="sapfincon-careers">SAP PS Consultant, Project Planner, Controller, EPC Project Manager</p>
        </div>
      </div>

      {/* Course Upgrade Section */}
      <div className="sapfincon-content-section">
        <div className="container">
          <div className="upgrade-section">
            <h2 className="section-title">
              <strong>Upgrade your project skills with BDM Technology's Expert-Led SAP PS Course!</strong>
            </h2>
            <p className="section-description">
              SAP PS helps businesses achieve complete control over project scope, timelines, budgets, and resource utilization — making it essential for engineering, infra, and capital-heavy industries.
            </p>
          </div>

          {/* Why Study */}
          <div className="why-study-section">
            <h3 className="subsection-title"><strong>Why Study SAP Project Systems (PS)?</strong></h3>
            <p className="subsection-description">
              SAP PS supports every phase of a project lifecycle and integrates with key modules like FICO, MM, and HR. This module is ideal for industries involved in infrastructure, engineering, construction, and manufacturing — where large-scale, deadline-driven projects are common.
            </p>
          </div>

          {/* Benefits */}
          <div className="benefits-section">
            <h3 className="subsection-title"><strong>Benefits of Learning SAP PS</strong></h3>
            <ul className="benefits-list">
              <li>Real-Time Project Monitoring – Timely delivery and cost optimization</li>
              <li>WBS, Milestones, Networks – Structured project control</li>
              <li>Multiple Career Paths – Consultant, Planner, Controller</li>
              <li>Cross-Industry Usage – EPC, telecom, manufacturing, public sector</li>
              <li>Integrated Project Execution – Aligns with finance, HR, and materials</li>
              <li>Improves Accountability – Enhances project governance and traceability</li>
            </ul>
          </div>

          {/* Future Scope */}
          <div className="future-scope-section">
            <h3 className="subsection-title"><strong>Future Scope of SAP PS</strong></h3>
            <ul className="scope-list">
              <li>Digitalized Project Control – Cloud-based and real-time analytics</li>
              <li>Integration with SAP PPM & S/4HANA – Future-proof platform</li>
              <li>Demand for Certified Professionals – Industry requires SAP PS experts</li>
              <li>Global Job Opportunities – Across industries and countries</li>
              <li>AI & Predictive Forecasting – Risk management and automation</li>
            </ul>
          </div>

          {/* Key Features */}
          <div className="key-features-section">
            <h3 className="subsection-title">
              <strong>Key Features of BDM Technology</strong>
            </h3>
            <div className="features-grid">
              {[
                ["100% Job-Oriented Training", "Curriculum tailored to industry requirements, ensuring you gain the skills employers are looking for."],
                ["Industry Expert Faculties", "Learn from seasoned professionals with real-world experience."],
                ["Flexible Demo Class Available", "Opportunity to attend a demo session and experience the training style before enrolling."],
                ["Completed 400+ Batches", "Proven track record with hundreds of successful batches, demonstrating program reliability and effectiveness."],
                ["Certification Guidance", "Support throughout your journey to help you earn relevant certifications that boost your career."],
                ["Live Practical Sessions", "Hands-on, interactive sessions to reinforce learning and apply concepts in real-time."],
                ["Peaceful Environment", "A conducive learning atmosphere that helps you focus and maximize your learning potential."]
              ].map(([title, desc], index) => (
                <div className="feature-item" key={index}>
                  <h4>{title}</h4>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Who Should Enroll */}
          <div className="who-attend-section">
            <h3 className="subsection-title"><strong>Who Should Enroll</strong></h3>
            <ul className="attend-list">
              <li>Project Engineers and Planners</li>
              <li>Professionals working in EPC, infrastructure, manufacturing, or utilities</li>
              <li>ERP aspirants and SAP consultants interested in project-driven industries</li>
              <li>MBA or Engineering graduates aiming for ERP-based project roles</li>
            </ul>
          </div>

          {/* Hiring Companies */}
          <div className="hiring-companies-section">
            <h3 className="subsection-title">
              <strong>Hiring Companies</strong>
            </h3>
            <div className="companies-grid">
              {[
                "/assets/img/Cognizant.png",
                "/assets/img/tcs.jpg",
                "/assets/img/infoysis.jpg",
                "/assets/img/ibm.png",
                "/assets/img/hcl.png",
                "/assets/img/Accenture.png",
                "/assets/img/capgemini.png",
                "/assets/img/Deloitte.png",
                "/assets/img/nttdata.png",
                "/assets/img/wipro.png",
                "/assets/img/KaarTech.png",
                "/assets/img/lt.png",
                "/assets/img/Siemens.png",
                "/assets/img/techmahindra.png"
              ].map((logo, index) => (
                <div className="company-card" key={index}>
                  <img src={logo} alt="Company Logo" className="company-logo" />
                </div>
              ))}
            </div>
          </div>

          {/* Salary Overview */}
          <div className="salary-overview-section">
            <h3 className="subsection-title">
              <strong>Salary Overview</strong>
            </h3>
            <div className="salary-grid">
              <div className="salary-item">
                <h4>Entry-Level (0-2 Years)</h4>
                <p className="salary-amount">₹5 - ₹8 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Mid-Level (2-5 Years)</h4>
                <p className="salary-amount">₹8 - ₹13 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Senior-Level (5+ Years)</h4>
                <p className="salary-amount">₹13 - ₹20+ LPA</p>
              </div>
              <div className="salary-item">
                <h4>SAP PS Architects & Project Controllers</h4>
                <p className="salary-amount">₹22 - ₹32+ LPA</p>
              </div>
            </div>
          </div>

          {/* Download PDF Section */}
          <div className="download-section">
            <h3 className="download-heading">
              Want to know more? <br />
              <span>Please download the course PDF.</span>
            </h3>
            <button className="download-button" onClick={handleDownloadClick}>
              📄 Download Course PDF
            </button>
          </div>

          {showForm && (
            <DownloadForm
              onClose={handleCloseForm}
              courseName="SAP PS"
              pdfUrl="/uploads/pdfs/05.pdf"
            />
          )}
        </div>
      </div>



  
    </div>
  );
};

export default SapPS;